import { PagerBaseComponent } from './pager-base.component';
import { PagerOptions } from './pager-options.model';

export class PagerModel<TModel> extends PagerBaseComponent<TModel>  {
  constructor(options: PagerOptions<TModel>) {
    super(options);
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/ng-structures/pager/pager.model.ts